import Axios from 'axios'
const path = () => `${window.$ApiHost}/settings/`

const state = {
  rogo_fee: '',
  rogo_email: '',
  lender_profit_limit: '',
  old_rogo_fee: '',
  old_rogo_email: '',
  old_lender_profit_limit: '',
}

const mutations = {
  setSettings(state, settings) {
    state.rogo_fee = settings.rogo_fee
    state.rogo_email = settings.rogo_email
    state.lender_profit_limit = settings.lender_profit_limit
    state.old_rogo_fee = settings.old_rogo_fee
    state.old_rogo_email = settings.old_rogo_email
    state.old_lender_profit_limit = settings.old_lender_profit_limit
  },
}

const actions = {
  async fetch({ commit }, params) {
    let res = null
    try {
      res = await Axios.get(path(), { params })
      commit('setSettings', res.data)
    } catch ({ response }) {
      res = response
    } finally {
    }
    return res
  },
  async edit({ commit }, data) {
    let res = null
    try {
      res = await Axios.put(path(), data)
    } catch ({ response }) {
      res = response
    } finally {
    }
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
